import React from "react";
import { Dialog, DialogContent, Typography, Grid, Card, CardContent, Button, Box, IconButton } from "@mui/material";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ImageUp from "../../../../assets/images/modal_1.png"
import ImageDown from "../../../../assets/images/modal_2.png"
import CloseIcon from '@mui/icons-material/Close';  // Close icon

const DashboardModal = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogContent >
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: '10px',
            right: '15px',
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>
        <Grid container spacing={2} className="Detail_Action_ViewContainer">
          <Grid item xs={12} md={7}>
            <Typography variant="h4" fontWeight="bold">
              WELCOME TO
            </Typography>
            <Typography variant="h4" fontWeight="bold" color="primary">
              TRAVEL CURIOUS ACTIVATE
            </Typography>
            <Typography variant="body1" sx={{ mt: 2 }}>
              Your gateway to Activating Your Brand, Elevating Your Customer Experience, and Driving Value through Loyalty and Ancillary Revenue.
            </Typography>

            <Grid container spacing={3} className="generalModuleCardContainer" style={{ padding: '20px 0' }}>
              <Grid item xs={12} md={6}>
                <Card className="cardHome" style={{ backgroundColor: '#d1e3f2' }}>
                  <CardContent style={{ flex: 1 }}>
                    <div className="sectionComponent">
                      <div className="label">Finish setting up your account</div >
                      <div className="subtitle">
                        Add contact info, bank details and other account information. Configure your Activate experience by adding account logo’s, colors and customizing your homepage.
                      </div >
                    </div>
                  </CardContent>
                  <Button className="buttonCardHome" variant="contained" color="primary">
                    Account Configuration&nbsp;&nbsp;&nbsp;<ArrowForwardIosIcon style={{ fontSize: '0.8rem' }} />
                  </Button>
                </Card>
              </Grid>

              <Grid item xs={12} md={6}>
                <Card className="cardHome" style={{ backgroundColor: '#d1e3f2' }}>
                  <CardContent>
                    <div className="sectionComponent">
                      <div className="label"> Create your first experience</div >
                      <div className="subtitle">
                        Ready to build your experiences? Simply follow the step-by-step guide to build your experience, add details like descriptions and images, and set detailed pricing schedules.
                      </div >
                    </div>
                  </CardContent>
                  <Button className="buttonCardHome" variant="contained" color="primary">
                    Experience Creation&nbsp;&nbsp;&nbsp;<ArrowForwardIosIcon style={{ fontSize: '0.8rem' }} />
                  </Button>
                </Card>
              </Grid>

              {/* Segunda fila */}
              <Grid item xs={12} md={6}>
                <Card className="cardHome" style={{ backgroundColor: '#d1e3f2' }}>
                  <CardContent>
                    <div className="sectionComponent">
                      <div className="label"> Create your first experience</div >
                      <div className="subtitle">
                        Ready to build your experiences? Simply follow the step-by-step guide to build your experience, add details like descriptions and images, and set detailed pricing schedules.
                      </div >
                    </div>
                  </CardContent>
                  <Button className="buttonCardHome" variant="contained" color="primary">
                    Experience Creation&nbsp;&nbsp;&nbsp;<ArrowForwardIosIcon style={{ fontSize: '0.8rem' }} />
                  </Button>
                </Card>
              </Grid>

              <Grid item xs={12} md={6}>
                <Card className="cardHome" style={{ backgroundColor: '#d1e3f2' }}>
                  <CardContent style={{ flex: 1 }}>
                    <div className="sectionComponent">
                      <div className="label">Finish setting up your account</div >
                      <div className="subtitle">
                        Add contact info, bank details and other account information. Configure your Activate experience by adding account logo’s, colors and customizing your homepage.
                      </div >
                    </div>
                  </CardContent>
                  <Button className="buttonCardHome" variant="contained" color="primary">
                    Account Configuration&nbsp;&nbsp;&nbsp;<ArrowForwardIosIcon style={{ fontSize: '0.8rem' }} />
                  </Button>
                </Card>
              </Grid>
            </Grid>

          </Grid>

          {/* Image section on the right*/}
          <Grid item xs={12} md={5}>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="space-between"  // To distribute space evenly between images
              height="100%"  // Ensures that the container occupies the entire available height
              mt={4}
            >
              <Box display="flex" justifyContent="center" flexGrow={1} alignItems="flex-start">
                <img src={ImageUp} width="100%" height="auto" alt="Image 1" />
              </Box>
              <Box display="flex" justifyContent="center" flexGrow={1} alignItems="flex-start">
                <img src={ImageDown} width="100%" height="auto" alt="Mockup 1" />
              </Box>
            </Box>
          </Grid>

        </Grid>
      </DialogContent>
    </Dialog >
  );
};

export default DashboardModal;
